export default function SFShuffleIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.7393 12.5626C20.1153 12.5626 20.455 12.4102 20.7013 12.1674C20.9477 11.9245 21.0981 11.5835 21.0981 11.2089C21.0981 10.8344 20.9451 10.496 20.7013 10.2505C20.5354 10.0852 20.3279 9.96379 20.0945 9.90179L7.49962 6.26449C7.25068 6.19474 7.00433 6.16632 6.76836 6.17149C6.19268 6.18957 5.67145 6.41949 5.27989 6.78632C4.88832 7.15315 4.62382 7.65431 4.56677 8.21747C4.50972 8.78063 4.65753 9.40321 5.0854 10.0103C5.53661 10.4159 6.02153 10.6329 6.49348 10.7026L19.7393 12.56V12.5626Z"
        fill="url(#paint0_linear_3_3413)"
      />
      <path
        d="M18.2456 18.53C19.0703 18.53 19.7393 17.8635 19.7393 17.042C19.7393 16.2205 19.1195 15.6083 18.339 15.5592L4.98946 14.699C3.8381 14.699 2.90198 15.6316 2.90198 16.7785C2.90198 17.9255 3.8381 18.8581 4.98946 18.8581L18.243 18.53H18.2456Z"
        fill="url(#paint1_linear_3_3413)"
      />
      <path
        d="M15.5485 3.24316C15.8235 3.01221 16 2.65649 16 2.2583C16 1.56278 15.4653 1 14.8045 1C14.5725 1 14.3581 1.06902 14.174 1.19113L5.19042 6.58269C4.48172 6.97558 4 7.75604 4 8.65596C4 9.95142 4.99622 11 6.22699 11C6.7995 11 7.33417 10.7717 7.74275 10.3974L15.5485 3.24316Z"
        fill="url(#paint2_linear_3_3413)"
      />
      <path
        d="M20.1278 12.6179C20.6383 12.4243 21 11.9312 21 11.3528C21 10.6067 20.3972 10 19.6558 10C19.4865 10 19.3249 10.0336 19.1736 10.0904L4.49808 14.9234C3.6336 15.1713 3 15.9716 3 16.9217C3 18.0706 3.92604 19 5.06499 19C5.37794 19 5.6755 18.9277 5.93972 18.8012L20.1253 12.6179H20.1278Z"
        fill="url(#paint3_linear_3_3413)"
      />
      <path
        d="M19.1632 18.0464C19.659 17.7812 20 17.2394 20 16.6084C20 15.7204 19.3232 15 18.489 15C18.1007 15 17.7466 15.1564 17.479 15.4133L10.2912 21.7211C10.1154 21.8468 10 22.059 10 22.3019C10 22.6873 10.2938 23 10.6558 23C10.7949 23 10.9234 22.9525 11.0283 22.8743L19.1632 18.0464Z"
        fill="url(#paint4_linear_3_3413)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3_3413"
          x1="12.826"
          y1="6.17149"
          x2="12.826"
          y2="19.8036"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4D12C0" />
          <stop offset="1" stopColor="#3F0A8F" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3_3413"
          x1="11.3219"
          y1="6.16372"
          x2="11.3219"
          y2="20.1136"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4D12C0" />
          <stop offset="1" stopColor="#3F0A8F" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3_3413"
          x1="1.74779"
          y1="11.9663"
          x2="15.677"
          y2="2.70079"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E300FF" />
          <stop offset="0.68" stopColor="#217BFF" />
          <stop offset="1" stopColor="#00F0B1" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3_3413"
          x1="6.81189"
          y1="17.6033"
          x2="21.4747"
          y2="7.40362"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E300FF" />
          <stop offset="0.68" stopColor="#217BFF" />
          <stop offset="1" stopColor="#00F0B1" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3_3413"
          x1="10.1836"
          y1="22.799"
          x2="23.1475"
          y2="14.2728"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E300FF" />
          <stop offset="0.68" stopColor="#217BFF" />
          <stop offset="1" stopColor="#00F0B1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
